import { mapGetters } from "vuex";
export default {
  data () {
    return {
      IsstopData: []
    }
  },
  computed: {
    ...mapGetters(["getmember", "getgameid", "getliveshow"]),
  },
  watch: {
    'getliveshow.reload': function () {
      // this.getApiData()
      this.pushIsstop()
    },
  },
  created () {
    this.pushIsstop()
  },
  methods: {
    async pushIsstop () {
      if (this.$route.name.split('-')[0] == 'liveshowAll') return
      try {
        const panelRes = await this.$axios.liveshow.gameSwitchList(this.getgameid)
        if ('status' in panelRes && panelRes.status === 0) return
        this.IsstopData = panelRes
      } catch (error) {
        console.log(error);
        this.$Notice.error({ title: `網路異常:(S3501-${this.getgameid})` })
      }
    },
    IsstopColor (res) {
      if (this.$route.name.split('-')[0] == 'liveshowAll' || !this.IsstopData.length) return
      if (!res && !res.length) return
      res.forEach(item => {
        const thispanel = this.IsstopData.find(it => it.odddtl == item.odddtl)
        item['isstop'] = thispanel.isstop
      })
    }
  },
}